import { render } from "./ProductHighlightPage.vue?vue&type=template&id=376ce0bc"
import script from "./ProductHighlightPage.vue?vue&type=script&lang=js"
export * from "./ProductHighlightPage.vue?vue&type=script&lang=js"

import "./ProductHighlightPage.vue?vue&type=style&index=0&id=376ce0bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__